import React from 'react';

interface LandingScreenProps {
  onContinue: () => void;
}

const LandingScreen: React.FC<LandingScreenProps> = ({ onContinue }) => {
  return (
    <div className="landing-screen">
      <div className="landing-content">
        <div className="landing-header">
          <h1 className="landing-title">Flip the Coin</h1>
          <p className="landing-subtitle">A calming way to make tough decisions</p>
        </div>

        <div className="landing-description">
          <p>
            Sometimes the hardest part of making a decision isn't choosing between options—it's
            knowing which option feels right to you.
          </p>

          <p>
            This app helps you externalize those tough choices through a simple coin flip ritual.
            Describe your situation, list your options, and let chance guide you to one. Then hear
            what a friend might say about your gut reaction.
          </p>

          <p>
            It's not about getting the "right" answer. It's about pausing to notice how you feel
            about the outcome—and using that awareness to make more confident choices going forward.
          </p>
        </div>

        <div className="landing-features">
          <div className="feature">
            <div className="feature-icon">🎯</div>
            <h3>Focus on Your Feelings</h3>
            <p>Notice your immediate reaction—relief, disappointment, or something else</p>
          </div>

          <div className="feature">
            <div className="feature-icon">🤖</div>
            <h3>Friend's Perspective</h3>
            <p>Get thoughtful reflections from an AI friend on your decision</p>
          </div>

          <div className="feature">
            <div className="feature-icon">🌱</div>
            <h3>Gentle Guidance</h3>
            <p>Supportive insights that help you understand yourself better</p>
          </div>
        </div>

        <div className="landing-cta">
          <button className="btn btn-primary" onClick={onContinue}>
            Let's Flip a Coin
          </button>
          <p className="landing-note">
            No account needed • Takes about 2 minutes • Your data stays private
          </p>
        </div>
      </div>
    </div>
  );
};

export default LandingScreen;
